import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { ThemeMode } from "@/theme";

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
  set: (m: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: "dark", // default dark per plan
      toggle: () => set((s) => ({ mode: s.mode === "dark" ? "light" : "dark" })),
      set: (m) => set({ mode: m })
    }),
    {
      name: "whb-theme",
      storage: createJSONStorage(() => localStorage)
    }
  )
);
